// extracted by mini-css-extract-plugin
module.exports = {"giftCardMessageInput":"giftCardMessageInput_giftCardMessageInput___e7l4"};